// Polish labels for the economy workspace (merged in economyTranslations.js).
export const economyLabelsPl = {
  appearance: "Wygląd",
  payrollTitle: "Szacowany koszt wynagrodzeń",
  payrollIntro: "Obliczony na podstawie zarejestrowanych godzin i zapisanych stawek. Stałe wynagrodzenie rozkładane jest według wymiaru etatu; potwierdzone nadgodziny otrzymują dodatek. Dodatek urlopowy, emerytura i składka pracodawcy są doliczane jako rezerwy kosztowe.",
  operatingTitle: "Szacowane miesięczne koszty operacyjne",
  operatingIntro: "Obliczone na podstawie zaksięgowanych dokumentów księgowych w wybranym okresie, pogrupowane według konta, dostawcy i kategorii. Pozycje można oznaczyć jako stałe lub zmienne.",
  vehiclesTitle: "Koszty pojazdów a moduł pojazdów",
  vehicleCosts: "Koszty samochodów",
  vehicleIntro: "Szacowany koszt opiera się na kredycie lub leasingu, kilometrach z ewidencji przebiegu i cenie energii. Porównaj z zaksięgowanymi kwotami powiązanymi z pojazdem.",
  budgetIntro: "Przygotuj plan na następny rok i porównaj rewizje z księgowością i prognozą.",
  liquidityTitle: "Płynność finansowa na następne 12 miesięcy",
  liquidityIntro: "Wpływy i wypływy z wybranego budżetu lub prognozy, z uwzględnieniem opóźnień płatności, zaliczek na podatek, składki pracodawcy (AGA), VAT i dodatku urlopowego.",
  liquidityNoBudget: "Brak dostępnego budżetu lub prognozy. Utwórz budżet w sekcji Budżet lub poczekaj, aż dane księgowe będą miały prognozę.",
  scenario: "Scenariusz",
  bufferPreset: "Bufor",
  buffer400k: "400k",
  buffer600k: "600k",
  buffer800k: "800k",
  revisions: "Wersje robocze i rewizje",
  selectRevision: "Wybierz rewizję, aby zobaczyć budżet.",
  calculated: "Obliczono",
  backToBudgets: "Budżet",
  sourceUpdated: "Zaktualizowano",
  revenueStep: "Przychody",
  periodChanged: "Kwoty miesięczne zapisano dla innego okresu początkowego. Sprawdź stare należności, zobowiązania i płatności, zanim ich tu użyjesz.",
  confirmPeriod: "Kwoty miesięczne zostały sprawdzone dla wybranego okresu",
  reapplyYear: "Rok został zmieniony. Zastosuj dane bazowe ponownie, aby zaktualizować okresy zatrudnienia.",
  forecastCashHelp: "Prognoza roczna jest rozkładana równomiernie na miesiące. Zaksięgowany koszt wynagrodzeń dzielony jest na brutto, emeryturę i rezerwy według zapisanych stawek firmy. Przed użyciem sprawdź to uproszczenie z danymi płacowymi.",
  suggestions: "Proponowane pozycje kosztowe",
  training: "Kursy i szkolenia",
  equipment: "Narzędzia i sprzęt",
  software: "Oprogramowanie",
  absence_review_required: "Wyjaśnij nieobecności w sekcji założeń.",
  invalid_deduction: "Potrącenie przekracza wynagrodzenie brutto.",
  absenceAdjustments: "Nieobecność i korekta wynagrodzenia",
  absenceReviewHelp: "Sprawdź wpływ nieobecności na wynagrodzenie. Wpisz tylko płatne godziny nieobecności, które nie zostały jeszcze ujęte w karcie czasu pracy. Stałe wynagrodzenie jest pomniejszane tylko o podaną kwotę.",
  paid_absence_hours: "Dodatkowe płatne godziny nieobecności",
  absence_deduction: "Potrącenie z wynagrodzenia w tym miesiącu (kr)",
  absenceConfirmed: "Nieobecność i korekta wynagrodzenia zostały sprawdzone",
  overlapping_employments: "Nakładające się okresy zatrudnienia wymagają wyjaśnienia.",
  employees: "pracowników",
  title: "Koszty, budżet i płynność finansowa",
  printPdf: "Drukuj PDF",
  printing: "Tworzenie PDF…",
  printFailed: "Nie udało się utworzyć PDF.",
  cashTitle: "Wpływy i wypływy",
  cashIntro: "Rzeczywiste wpływy to faktury dla klientów. Rzeczywiste wypływy to faktury dostawców i zaksięgowane wynagrodzenia, do wybranego miesiąca włącznie. Szacowane wpływy i wypływy to prognoza roczna z danych księgowych, a nie faktury.",
  actualIn: "Rzeczywiste wpływy",
  actualOut: "Rzeczywiste wypływy",
  estimatedIn: "Szacowane wpływy",
  estimatedOut: "Szacowane wypływy",
  customerInvoices: "Faktury dla klientów",
  supplierInvoices: "Faktury dostawców",
  bookedPayroll: "Zaksięgowane wynagrodzenia",
  annualProjection: "Prognoza roczna z księgowości",
  throughPeriod: "Do {{month}} {{year}} włącznie",
  eyebrow: "Szacunki i planowanie",
  payroll: "Koszt wynagrodzeń",
  operating: "Koszty operacyjne",
  vehicles: "Pojazdy",
  budgets: "Budżet",
  liquidity: "Płynność finansowa",
  light: "Jasny",
  dark: "Ciemny",
  year: "Rok",
  month: "Miesiąc",
  loading: "Pobieranie danych…",
  retry: "Pobierz ponownie",
  save: "Zapisz",
  saving: "Zapisywanie…",
  saved: "Zapisano",
  close: "Zamknij",
  cancel: "Anuluj",
  edit: "Edytuj",
  settings: "Założenia",
  missing: "Brak danych",
  noEmployees: "Brak pracowników w tym okresie.",
  noVehicles: "Brak aktywnych pojazdów.",
  source: "Lokalne dane księgowe",
  methodology: "Jak obliczane są wartości",
  payrollHelp: "Wynagrodzenie godzinowe opiera się na zarejestrowanych godzinach i potwierdzonych nadgodzinach. Stałe wynagrodzenie jest korygowane o wymiar etatu i dni kalendarzowe w okresie zatrudnienia. Nieobecności należy wyjaśnić w założeniach, podając płatne godziny i potrącenia. Dodatek urlopowy, emerytura i składka pracodawcy (AGA) są doliczane jako rezerwy kosztowe. Potwierdź stawki w założeniach.",
  name: "Nazwa",
  employee: "Pracownik",
  hours: "Godziny",
  gross: "Wynagrodzenie brutto",
  holiday: "Dodatek urlopowy",
  pension: "Emerytura",
  employer_tax: "Składka pracodawcy",
  total: "Łącznie",
  cost_per_hour: "Koszt za godzinę",
  holiday_percent: "Dodatek urlopowy (%)",
  pension_percent: "Emerytura (%)",
  employer_tax_percent: "Składka pracodawcy (%)",
  overtime_percent: "Dodatek za nadgodziny (%)",
  monthly_norm_hours: "Godziny normatywne miesięcznie przy 100%",
  rate: "Stawka wynagrodzenia przy 100%",
  employment_percent: "Wymiar etatu (%)",
  hourly: "Godzinowe",
  monthly: "Miesięcznie",
  annual: "Rocznie",
  once: "Jednorazowo",
  reference: "Z umowy o pracę",
  partial: "Suma obejmuje tylko pracowników z prawidłowymi danymi.",
  unknown: "Brak odpowiedzi. Sprawdź zapisany status, zanim wprowadzisz kolejne zmiany.",
  conflict: "Istnieje nowsza wersja lub rekord jest zablokowany. Zachowaj wersję roboczą i porównaj ją z zapisaną wersją.",
  checkStatus: "Sprawdź zapisany status",
  lastMonth: "Ostatni miesiąc",
  average3: "Średnia z 3 miesięcy",
  average6: "Średnia z 6 miesięcy",
  account: "Konto",
  postings: "Księgowania",
  monthlyEstimate: "Szacunek miesięczny",
  annualEstimate: "Szacunek roczny",
  operatingHelp: "Średnia z wybranych pełnych miesięcy z rachunku zysków i strat. Szacunek roczny to szacunek miesięczny × 12. Dokumenty księgowe i faktury dostawców podlegają istniejącym regułom raportu zapobiegającym podwójnemu liczeniu. Grupy kont są orientacyjne. Podział według dostawców wykorzystuje dostawcę z faktury powiązanej z tym samym dokumentem księgowym.",
  syncMissing: "Przed użyciem tych danych bazowych należy zsynchronizować księgowość.",
  details: "Pokaż dokumenty księgowe",
  materials: "Materiały i koszt towarów",
  premises: "Lokale",
  it: "IT i biuro",
  insurance: "Ubezpieczenie",
  other: "Inne koszty",
  revenue: "Obrót",
  result: "Wynik",
  cost: "Koszty",
  kilometers: "Przejechane kilometry",
  consumption_per_100km: "Litry/kWh na 100 km",
  energy_price: "Cena za litr/kWh (kr)",
  insurance_monthly: "Ubezpieczenie miesięcznie",
  road_tax_monthly: "Opłata za ubezpieczenie OC miesięcznie",
  financing: "Finansowanie",
  owned: "Własny bez kredytu",
  loan: "Kredyt",
  leasing: "Leasing",
  loan_balance: "Pozostały kredyt",
  interest_percent: "Roczne oprocentowanie (%)",
  remaining_months: "Pozostałe miesiące",
  leasing_monthly: "Leasing miesięcznie",
  leasing_km_year: "Umowne kilometry rocznie",
  leasing_excess_per_km: "Cena za kilometr ponad limit",
  energy: "Paliwo / prąd",
  road_tax: "Opłata za ubezpieczenie OC",
  interest: "Odsetki",
  principal: "Rata kapitałowa",
  operating_cost: "Obliczony koszt",
  cash_out: "Wypływ gotówki",
  cost_per_km: "Koszt za km",
  vehicleHelp: "Przebieg pochodzi z ewidencji przebiegu. Kredyt jest obliczany jako annuitet na podstawie podanego pozostałego kredytu i okresu spłaty. Rata kapitałowa jest pokazywana oddzielnie od kosztu; amortyzacja nie jest obliczana. Zużycie, cenę energii, ubezpieczenie i opłatę należy potwierdzić.",
  newBudget: "Nowy budżet",
  basis: "Dane bazowe",
  projected: "Prognoza roczna",
  actual: "Rzeczywista księgowość",
  copy: "Kopia wersji roboczej",
  blank: "Pusty budżet",
  owner: "Odpowiedzialny",
  note: "Notatka",
  seasonal: "Rozkład sezonowy",
  even: "Rozkład równomierny",
  applyBasis: "Użyj tych danych bazowych",
  growth: "Wzrost (%)",
  quarterly: "Kwoty kwartalne",
  revenue_percent: "Udział w obrocie (%)",
  quarter: "Kwartał",
  staff: "Obsada",
  annual_salary: "Roczne wynagrodzenie przy 100%",
  from_month: "Od miesiąca",
  to_month: "Do miesiąca",
  included: "Uwzględnij",
  addPosition: "Dodaj stanowisko",
  remove: "Usuń",
  customLines: "Własne pozycje kosztowe",
  addLine: "Dodaj koszt",
  review: "Podsumowanie",
  next: "Dalej",
  previous: "Wstecz",
  fte: "Etaty (FTE)",
  headcount: "Liczba pracowników",
  accumulated_result: "Wynik skumulowany",
  draft: "Wersja robocza",
  submitted: "Do zatwierdzenia",
  approved: "Zatwierdzony",
  superseded: "Zastąpiony",
  submit: "Wyślij do zatwierdzenia",
  return: "Przywróć do wersji roboczej",
  approve: "Zatwierdź",
  history: "Historia",
  compare: "Porównaj",
  difference: "Różnica",
  noBudgets: "Brak budżetów.",
  low_margin: "Marża wyniku jest poniżej 5%.",
  high_payroll_share: "Koszt wynagrodzeń przekracza 50% obrotu.",
  zero_growth_baseline: "Wzrost przy zerowych danych bazowych nadal daje zero.",
  budgetHelp: "Obliczenia są wykonywane na serwerze. Zapisane wersje robocze zachowują dane bazowe i rozkład miesięczny. Zatwierdzona rewizja jest blokowana; nowe zatwierdzenie zastępuje poprzednio zatwierdzoną rewizję.",
  unsaved: "Wersja robocza nie jest zapisana.",
  discard: "Odrzuć wersję roboczą",
  more: "Pokaż więcej",
  value: "Kwota / stawka",
  method: "Metoda",
  status: "Status",
  updated: "Zaktualizowano",
  starting_balance: "Początkowe wolne środki w banku",
  buffer: "Minimalny bufor",
  revenue_change_percent: "Scenariusz: zmiana przychodów (%)",
  cost_change_percent: "Scenariusz: zmiana kosztów operacyjnych (%)",
  vat_percent: "Stawka VAT (%)",
  taxable_revenue_percent: "Udział przychodów objętych VAT (%)",
  withholding_percent: "Szacowana zaliczka na podatek (%)",
  receipt_delay_months: "Płatność klienta: miesiące po przychodzie",
  supplier_delay_months: "Płatność dostawcy: miesiące po koszcie",
  deductible_vat_percent: "Udział z VAT do odliczenia (%)",
  opening_receipts: "Wpływy z wcześniejszych należności",
  opening_supplier_payments: "Spłata wcześniejszych zobowiązań wobec dostawców",
  opening_aga: "Wcześniej naliczona składka pracodawcy (AGA) do zapłaty",
  opening_vat: "Wcześniejszy VAT do zapłaty / zwrotu",
  holiday_pay: "Planowana wypłata dodatku urlopowego",
  salary_deduction: "Potrącenie z wynagrodzenia za urlop",
  other_cash: "Inne wpływy/wypływy (+/−)",
  receipts: "Wpływy",
  suppliers: "Dostawcy i koszty operacyjne",
  net_pay: "Wynagrodzenie netto i dodatek urlopowy",
  withholding: "Zaliczka na podatek",
  vat: "Rozliczenie VAT",
  outflows: "Wypływy",
  net_cash: "Przepływy pieniężne netto",
  opening_balance: "Saldo początkowe",
  closing_balance: "Saldo końcowe",
  minimum_balance: "Najniższe saldo na koniec miesiąca",
  ending_balance: "Saldo na koniec okresu",
  months_below_buffer: "Miesiące poniżej bufora",
  cautious: "Ostrożny",
  expected: "Oczekiwany",
  optimistic: "Optymistyczny",
  calculate: "Oblicz prognozę",
  nextYearBudget: "Budżet na następny rok",
  liquidityHelp: "Prognoza miesięczna z wybranych budżetów, z podanymi opóźnieniami płatności. Zaliczka na podatek jest ujęta w łącznej wypłacie wynagrodzeń w tym samym miesiącu; to nie jest kalendarz płatności. Składka pracodawcy (AGA) jest płacona w miesiącu po okresie dwumiesięcznym, zwykły VAT dwa miesiące po okresie. Wpisz stare należności, zobowiązania i saldo dodatku urlopowego w miesiącu ich zapłaty. Raty kapitałowe i inne ruchy gotówki należy wprowadzić osobno. Ten model nie obsługuje rocznego rozliczenia VAT.",
  booked: "Powiązana kwota zaksięgowana",
  linkPosting: "Powiąż dokument księgowy z pojazdem",
  unlink: "Usuń powiązanie",
  toll: "Opłaty drogowe i parkowanie",
  service: "Warsztat i serwis",
  unallocated: "Dokumenty księgowe bez powiązania z pojazdem",
  mappingHelp: "Porównanie obejmuje tylko księgowania powiązane z tym pojazdem. Wybierz właściwą pozycję kosztową z dokumentu księgowego; nie powiązuj dodatkowo zapisu bankowego/przeciwstawnego. Kwoty bez powiązanych księgowań są nieznane.",
  useSaved: "Odrzuć wersję roboczą i użyj zapisanej wersji",
  copyDraft: "Zachowaj jako nową wersję roboczą",
  historicalYear: "Historyczny rok obrotowy",
  loadFailed: "Nie udało się pobrać danych. Spróbuj pobrać ponownie.",
  invalid: "Sprawdź wartość.",
  row: "Wiersz",
  fixed: "Koszty stałe",
  variable: "Koszty zmienne",
  unclassified: "Niesklasyfikowane",
  estimated_annual_km: "Kilometry roczne przy takim samym użyciu miesięcznym",
  estimated_excess_km: "Szacowane przekroczenie (km)",
  estimated_excess_cost: "Szacowany koszt przekroczenia limitu",
  suppliersTitle: "Dostawcy",
  suppliersHelp: "Kto fakturował koszty operacyjne w wybranych miesiącach, na podstawie faktury dostawcy powiązanej z dokumentem księgowym.",
  supplier: "Dostawca",
  invoices: "Faktury",
  unknownSupplier: "Nieznany dostawca",
  noSuppliers: "Brak dostawców w wybranych miesiącach.",
  categoriesTitle: "Kategorie",
  categoriesHelp: "Te same grupy kont co w danych przeglądu: materiały, pojazdy, lokale, IT, ubezpieczenie i inne.",
  category: "Kategoria",
  efficiencyTitle: "Efektywność",
  efficiencyHelp: "Porównuje ostatni miesiąc ze średnią z wybranych miesięcy. Oznacza tylko odchylenia na tyle duże, że widać je w liczbach, a nie ogólne porady.",
  efficiencyHigh: "{{name}} jest o {{percent}}% powyżej średniej z wybranych miesięcy. Sprawdź, czy zakupy można ograniczyć lub przesunąć.",
  efficiencyHighAccount: "Konto {{name}} jest o {{percent}}% powyżej średniej z wybranych miesięcy.",
  efficiencyUnclassified: "Konta nieoznaczone jako stałe lub zmienne: {{count}}. Klasyfikacja ułatwia oddzielenie niezbędnych kosztów stałych od zakupów, którymi można sterować.",
  efficiencySmallInvoices: "{{name}}: małe faktury lub dokumenty księgowe w okresie: {{count}}. Łącz zakupy lub anuluj nieużywane subskrypcje.",
  efficiencyOk: "Brak wyraźnych odchyleń w wybranych miesiącach poza tym, co już pokazują tabele.",
};
